import styled, { css } from 'styled-components';

export const WhitespaceStyled = styled.div`
  margin: 0 0 24px;
`;

export const StickyContainerStyled = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
`;

export const ContainerStyled = styled(StickyContainerStyled)`
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  background: var(
    --ds-background-accent-gray-subtlest,
    var(--ds-fb-background-accent-gray-subtlest)
  );
  box-shadow: var(--ds-shadow-overflow, var(--ds-fb-shadow-overflow));

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 32px;

  padding: 0 16px;
  margin: 0 0 8px;

  align-items: stretch;
`;

export const SlotElementStyled = css`
  height: 100%;
  display: flex;
  place-content: center;
  place-items: center;
`;

export const LeftSlotStyled = styled.div`
  ${SlotElementStyled}

  max-width: 432px;
  justify-self: start;
`;

export const RightSlotStyled = styled.div`
  ${SlotElementStyled}

  max-width: 432px;
  justify-self: end;
`;

export const MiddleSlotStyled = styled.div`
  ${SlotElementStyled}

  max-width: 464px;
  justify-self: center;
`;

export const TitleLinkStyled = styled.button`
  border: none;
  background: none;
  color: var(--ds-text, var(--ds-fb-text));

  padding: 0;
  margin: 0;

  cursor: pointer;

  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  max-width: 464px;

  :hover {
    text-decoration: underline;
  }
`;
